var exports = {
  "kL": "xa15a2ab7--f13531--container",
  "DD": "xa15a2ab7--f13531--title",
  "Qq": "xa15a2ab7--f13531--text",
  "nn": "xa15a2ab7--f13531--buttons-wrap",
  "WW": "xa15a2ab7--f13531--button-wrap",
};

module.exports = exports;
